import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestCardProcessingRatesWrapper from "@components/layouts/bestCardProcessingRatesWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function BestCardProcessingRatesHome(): ReactElement {
    return (
        <BestCardProcessingRatesWrapper>
            <div className="max-w-7xl mx-auto block px-4vw lg:px-4">
                <TermsAndConditions
                    category="Card Processing"
                    domain="BestCardProcessingRates.com"
                />
            </div>
        </BestCardProcessingRatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
